export const ACTIVE_EVENT_DELETED = 'ACTIVE_EVENT_DELETED';
export const ACTIVE_EVENT_UPDATED = 'ACTIVE_EVENT_UPDATED';
export const EVENT_CREATED = 'EVENT_CREATED';
export const EVENT_SAVED_SUCCESS = 'EVENT_SAVED_SUCCESS';
export const EVENT_FETCHED = 'EVENT_FETCHED';
export const EVENTS_FETCHED = 'EVENTS_FETCHED';
export const EVENTS_REQUESTED = 'EVENTS_REQUESTED';
export const EVENTS_REQUESTED_ERROR = 'EVENTS_REQUESTED_ERROR';
export const EVENTS_REQUESTED_SUCCESS = 'EVENTS_REQUESTED_SUCCESS';
export const EVENTS_RESET = 'EVENTS_RESET';

export const createEvent = () => ({ type: EVENT_CREATED });
export const saveEventSuccess = eventId => ({ type: EVENT_SAVED_SUCCESS, eventId });
export const deleteActiveEvent = () => ({ type: ACTIVE_EVENT_DELETED });
export const fetchEvent = eventId => ({ type: EVENT_FETCHED, eventId });
export const fetchEvents = () => ({ type: EVENTS_FETCHED });
export const requestEvents = () => ({ type: EVENTS_REQUESTED });
export const requestEventsError = () => ({ type: EVENTS_REQUESTED_ERROR });
export const requestEventsSuccess = events => ({ type: EVENTS_REQUESTED_SUCCESS, events });
export const resetEvents = () => ({ type: EVENTS_RESET });
export const updateActiveEvent = () => ({ type: ACTIVE_EVENT_UPDATED });



// WEBPACK FOOTER //
// ./src/redux/actions/events.js